import React from 'react';
import ReactDOM from 'react-dom';
import CommonChrome from './CommonChrome';
export { AccountDropdown, AccountMenuItem, AppSwitcher, Avatar, Content, ContextConsumer, ContextProvider, Logo, Nav, NavDropdown, NavMenuDivider, NavMenuHeading, NavMenuItem, NavSearch, Section } from './CommonChrome';
export default CommonChrome;
export var mountComponent = function mountComponent(componentName, target) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var Component = CommonChrome[componentName];

  if (Component) {
    ReactDOM.render( /*#__PURE__*/React.createElement(Component, props), target);
  }
};
export var mount = function mount(target) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return ReactDOM.render( /*#__PURE__*/React.createElement(CommonChrome, props), target);
};